'use strict';

var SummaryKpiRibbonAggregationFactory = function SummaryKpiRibbonAggregationFactory(AbstractRomKpiRibbonAggregationFactory) {
  function SummaryKpiRibbonAggregation() {
    AbstractRomKpiRibbonAggregationFactory.call(this, ['rom-summary-mode'], 'kpi-ribbon');
  }
  SummaryKpiRibbonAggregation.prototype = Object.create(AbstractRomKpiRibbonAggregationFactory.prototype);
  SummaryKpiRibbonAggregation.constructor = SummaryKpiRibbonAggregation;
  SummaryKpiRibbonAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  SummaryKpiRibbonAggregation.prototype.aggregate = function (data, metricsKeys) {
    var grouped = {};
    if (data.length === 0) {
      return grouped;
    }

    //go through all weeks day and group data for one optGroupWeek in grouped arr
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var item = data[index];
      // put in args the same group item and recalculate all values
      grouped = this.group(item.week, metricsKeys, grouped);
    }
    var aggregated = this.lastOptGroupWeekData(grouped);
    return this.calcGap(aggregated.data);
  };
  return SummaryKpiRibbonAggregation;
};
SummaryKpiRibbonAggregationFactory.$inject = ['AbstractRomKpiRibbonAggregationFactory'];
module.exports = SummaryKpiRibbonAggregationFactory;